import type { CheckoutConfig } from '#types/config/components/checkout'

export default {
  brandClasses: {
    title: 'timberland:!subtitle-8 title-4',
  }
} satisfies CheckoutConfig['billingAddress']
